(function () {
  const esc = (window.CSS && CSS.escape) ? CSS.escape : (s) => String(s).replace(/(["\\])/g, '\\$1');

  // Нормалізуємо properties для порівняння
  function stableProps(obj) {
    const out = {};
    if (!obj) return out;
    Object.keys(obj)
      .filter(k => k && !k.startsWith('_') && obj[k] !== null && obj[k] !== '')
      .sort()
      .forEach(k => { out[k] = String(obj[k]); });
    return out;
  }

  // Збереження властивостей
  document.addEventListener('click', async (e) => {
    const saveBtn = e.target.closest('.js-props-save');
    if (!saveBtn) return;

    const oldKey = saveBtn.dataset.key;
    const variantId = Number(saveBtn.dataset.variantId || 0);
    const dialog = saveBtn.closest('cart-note-dialog');
    if (!oldKey || !variantId || !dialog) return;

    const inputs = dialog.querySelectorAll('[data-prop-key]');
    const properties = {};
    inputs.forEach((inp) => { properties[inp.dataset.propKey] = inp.value; });

    saveBtn.disabled = true;

    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: oldKey, properties })
      });
      if (!res.ok) throw new Error('Request failed');
      const cart = await res.json();

      // 1) Підміняємо текст у списку без перезавантаження
      const lineItemEl = dialog.closest('line-item');
      if (lineItemEl) {
        inputs.forEach((inp) => {
          const el = lineItemEl.querySelector(`li[data-prop-item="${esc(inp.dataset.propKey)}"] .line-prop-value`);
          if (el) el.textContent = inp.value;
        });
      }

      // 2) Знаходимо НОВИЙ ключ (бо key змінився) і оновлюємо всі data-key у цьому рядку
      const posted = stableProps(properties);
      const newItem = (cart.items || []).find(it =>
        Number(it.variant_id) === variantId &&
        JSON.stringify(stableProps(it.properties)) === JSON.stringify(posted)
      );

      if (newItem && newItem.key) {
        // оновлюємо кнопку Save
        saveBtn.dataset.key = newItem.key;

        // оновлюємо всі інші кнопки/іконки в цьому рядку, які мають data-key
        if (lineItemEl) {
          lineItemEl.querySelectorAll('[data-key]').forEach(btn => { btn.dataset.key = newItem.key; });
        }
      }

      // Prestige 11.4 refreshes the drawer and all dependent bundled sections on this event.
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    } catch (err) {
      console.warn('Failed to update line item properties', err);
      alert('Не вдалося зберегти опції. Спробуй ще раз.');
    } finally {
      saveBtn.disabled = false;
    }
  });
})();
